
export enum CurrencyCd {
	CANADIAN_DOLLARS = 'CanadianDollars',
	MEXICAN_PESO = 'MexicanPeso',
	US_DOLLARS = 'USDollars'}

